// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"1310":"55450a8fa9befec0","1546":"cacc1f71ee815538","3794":"1932b9c84b6d0ca6"}[chunkId] + ".css";
};